import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  TextField,
  Typography,
  Button,
  Box,
  Checkbox,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import { useMessage } from "../../context/message-context";
import { useConfirm } from "../../context/confirm-context";
function ArtikelTable(props) {
  const { t } = useTranslation();
  //Standardfelder
  const theme = useTheme();

  const {
    lock,
    artikel,
    open,
    onOpenChange,
    changeValue,
    settings,
    steuerSaetze,
    artikelOptionen,
    neueArtikelBerechnen,
    editModus,
    setEditModus,
    selectedTab,
    setSelectedTab,
    addArtikel,
    selectedArtikel,
    letzteAenderung,
    setLetzteAenderung,
    setSelectedArtikel,
    fehlerFound,
    setFehlerFound,
    belegWerte,
  } = props;
  const { showErrorMessage } = useMessage();
  const confirm = useConfirm();
  const changeWerte = (value, was) => {
    if (/[a-zA-Z]/.test(value) && !"Artikelbezeichnung;ARTIKEL_KEY;".includes(was + ";")) {
      showErrorMessage("Bitte geben Sie nur gültige Zahlen ein.");
      return;
    }
    const zwis = selectedArtikel;
    if (was === "Artikelbezeichnung") {
      zwis[was] = value;
      setSelectedArtikel({ ...zwis });
      return;
    }

    const wert = parseFloat(value.replace(",", "."));

    zwis[was] = value.replace(",", ".");
    if (was === "STEUERSATZ" && wert === "") {
      zwis[was] = 0;
    }
    // Wenn der NETTO-Wert geändert wurde, berechne die MWST und BETRAG
    if (was === "NETTO") {
      setLetzteAenderung(was);
      zwis["STEUER"] = ((wert * zwis["STEUERSATZ"]) / 100).toFixed(2);
      zwis["BETRAG"] = (wert + (wert * zwis["STEUERSATZ"]) / 100).toFixed(2);
    }
    // Wenn der STEUERSATZ geändert wurde, berechne die STEUER und BETRAG
    if (was === "STEUERSATZ") {
      if (letzteAenderung === "BETRAG") {
        const STEUER = ((zwis["BETRAG"] / (100 + wert)) * wert).toFixed(2);
        zwis["STEUER"] = STEUER;
        zwis["NETTO"] = (parseFloat(zwis["BETRAG"]) - parseFloat(STEUER)).toFixed(2);
      } else {
        const STEUER = ((zwis["NETTO"] * wert) / 100).toFixed(2);
        zwis["STEUER"] = STEUER;
        zwis["BETRAG"] = (parseFloat(zwis["NETTO"]) + parseFloat(STEUER)).toFixed(2);
      }
    }
    // Wenn der BETRAG geändert wurde, berechne die NETTO und STEUER
    if (was === "BETRAG") {
      setLetzteAenderung(was);
      if (zwis["STEUERSATZ"] === "0") {
        zwis["STEUER"] = "0";
        zwis["NETTO"] = wert.toFixed(2);
      } else {
        const STEUER = parseFloat((wert / (100 + parseInt(zwis["STEUERSATZ"]))) * parseInt(zwis["STEUERSATZ"]));
        zwis["STEUER"] = STEUER.toFixed(2);
        zwis["NETTO"] = ((wert / (100 + parseInt(zwis["STEUERSATZ"]))) * 100).toFixed(2);
      }
    }
    setSelectedArtikel({ ...zwis });
  };
  const editArtikel = (artikel, index) => {
    setSelectedArtikel({ ...artikel, index });
    setEditModus(true);
  };
  const saveArtikel = () => {
    if (artikelOptionen && !selectedArtikel.ARTIKEL_KEY) {
      showErrorMessage("Bitte einen Artikel hinterlegen!");
      return;
    }
    if (isNaN(parseInt(selectedArtikel.NETTO)) || parseInt(selectedArtikel.NETTO) === 0) {
      showErrorMessage("Bitte geben Sie einen gültigen Nettowert ein. Ein Wert von 0 ist nicht zulässig.");
      return;
    }
    if (isNaN(parseInt(selectedArtikel.BETRAG)) || parseInt(selectedArtikel.BETRAG) === 0) {
      showErrorMessage("Bitte geben Sie einen gültigen Bruttowert ein. Ein Wert von 0 ist nicht zulässig.");
      return;
    }
    if (isNaN(parseInt(selectedArtikel.STEUERSATZ))) {
      showErrorMessage("Bitte geben Sie einen Steuersatz ein.");
      return;
    }
    var steuerSatz = parseInt(selectedArtikel.STEUERSATZ);
    if (steuerSatz !== 7 && steuerSatz !== 19 && steuerSatz !== 0 && belegWerte.SITZ === "J") {
      confirm({
        text:
          "Steuersatz " +
          steuerSatz +
          "% für Deutschland ungewöhnlich, bei ausländischen Belegen bitte Brutto mit Steuersatz 0 eintragen. Wollen Sie den Artikel trotzdem speichern ?",
        title: "Steuersatz",
        buttons: "YESNO",
      })
        .then((antwort) => {
          changeValue("ARTIKEL", selectedArtikel);
          setFehlerFound(false);
          setEditModus(false);
        })
        .catch((antwort) => {
          return;
        });
    } else {
      changeValue("ARTIKEL", selectedArtikel);
      setFehlerFound(false);
      setEditModus(false);
    }
  };
  const removeArtikel = (index) => {
    changeValue("ARTIKEL_REMOVE", index);
    setSelectedTab(0);
  };
  const closeDialog = () => {
    if (editModus) {
      showErrorMessage("Sie haben noch einen Artikel in der Bearbeitung. Bearbeitung bitte erst speichern oder verwerfen!");
      return;
    }
    onOpenChange(false);
    setSelectedArtikel([]);
    setEditModus(false);
    neueArtikelBerechnen();
  };

  const displayMobileAnsicht = () => {
    return (
      <>
        {!artikel && !editModus ? (
          <></>
        ) : (
          <Tabs value={selectedTab} onChange={(event, newValue) => setSelectedTab(newValue)} variant="scrollable" disabled={editModus} scrollButtons="auto">
            {artikel?.map((expense, count) => (
              <Tab disabled={editModus} value={count} key={count} label={t("Artikel ") + parseInt(count + 1)} />
            ))}
            {editModus && !artikel[selectedTab] && <Tab key={selectedArtikel.index} label={t("Neuer Artikel ")} />}
          </Tabs>
        )}
        {artikel && artikel[selectedTab] && !editModus && (
          <Box sx={{ p: 2 }}>
            <TextField
              fullWidth
              variant="standard"
              disabled
              sx={{ mb: 2 }}
              label="Artikelbezeichnung"
              value={artikel[selectedTab].Artikelbezeichnung}
              onChange={(e) => changeWerte(e.target.value, "Artikelbezeichnung")}
            ></TextField>

            {artikelOptionen ? (
              <TextField
                size="small"
                fullWidth
                label="Artikel"
                select
                disabled
                sx={{ mb: 2 }}
                variant="standard"
                onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                value={artikel[selectedTab]?.ARTIKEL_KEY ? artikel[selectedTab]?.ARTIKEL_KEY : ""}
              >
                {artikelOptionen?.map((artikel) => {
                  return (
                    <MenuItem key={artikel.key} value={artikel.key} index={artikel.key}>
                      {artikel.bez}
                    </MenuItem>
                  );
                })}
              </TextField>
            ) : (
              <>
                {settings?.betreffVorgaben !== "" && settings?.betreffVorgaben !== undefined && (
                  <TextField
                    variant="standard"
                    size="small"
                    fullWidth
                    label="Artikel Art"
                    select
                    sx={{ mb: 2 }}
                    disabled
                    onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                    value={artikel[selectedTab]?.ARTIKEL_KEY ? artikel[selectedTab]?.ARTIKEL_KEY : ""}
                  >
                    {settings?.betreffVorgaben?.split("\n").map((item2, index2) => {
                      var tmpkey = "";
                      var tmpval = "";
                      var tmppos = item2.indexOf(";");
                      if (tmppos >= 0) {
                        tmpkey = item2.substr(0, tmppos);
                        tmpval = item2.substr(tmppos + 1);
                      } else {
                        tmpkey = item2;
                        tmpval = item2;
                      }
                      return (
                        <MenuItem key={tmpval} value={tmpval} index={index2}>
                          {tmpval}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                )}
              </>
            )}

            <TextField
              value={artikel[selectedTab].NETTO}
              label="Netto"
              sx={{ mb: 2 }}
              disabled
              fullWidth
              variant="standard"
              onChange={(e) => changeWerte(e.target.value, "NETTO")}
            ></TextField>
            <TextField value={artikel[selectedTab].STEUER} label="Steuer" sx={{ mb: 2 }} disabled fullWidth variant="standard"></TextField>
            <TextField
              value={artikel[selectedTab].STEUERSATZ}
              label="Steuersatz"
              disabled
              sx={{ mb: 2 }}
              fullWidth
              variant="standard"
              onChange={(e) => changeWerte(e.target.value, "STEUERSATZ")}
            ></TextField>
            <TextField
              value={artikel[selectedTab].BETRAG}
              disabled
              label="Brutto"
              fullWidth
              variant="standard"
              onChange={(e) => changeWerte(e.target.value, "BETRAG")}
            ></TextField>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <IconButton color="secondary" disabled={lock || editModus} fullWidth onClick={() => editArtikel(artikel[selectedTab], selectedTab)}>
                <EditIcon />
              </IconButton>{" "}
              <IconButton color="secondary" disabled={lock || editModus} fullWidth onClick={() => removeArtikel(selectedTab)}>
                {" "}
                <CloseIcon />{" "}
              </IconButton>
            </Box>
          </Box>
        )}
        {editModus && (
          <Box sx={{ p: 2 }}>
            <TextField
              fullWidth
              variant="standard"
              label="Artikelbezeichnung"
              sx={{ mb: 2 }}
              onFocus={(event) => {
                event.target.select();
              }}
              value={selectedArtikel?.Artikelbezeichnung}
              onChange={(e) => changeWerte(e.target.value, "Artikelbezeichnung")}
            ></TextField>
            {artikelOptionen ? (
              <TextField
                size="small"
                fullWidth
                label="Artikel"
                select
                variant="standard"
                onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                value={selectedArtikel?.ARTIKEL_KEY ? selectedArtikel?.ARTIKEL_KEY : ""}
              >
                {artikelOptionen?.map((artikel) => {
                  return (
                    <MenuItem key={artikel.key} value={artikel.key} index={artikel.key}>
                      {artikel.bez}
                    </MenuItem>
                  );
                })}
              </TextField>
            ) : (
              <>
                {settings?.betreffVorgaben !== "" && settings?.betreffVorgaben !== undefined && (
                  <TextField
                    variant="standard"
                    size="small"
                    fullWidth
                    select
                    sx={{ mb: 2 }}
                    label="Artikel Art"
                    onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                    value={selectedArtikel?.ARTIKEL_KEY ? selectedArtikel?.ARTIKEL_KEY : ""}
                  >
                    {settings?.betreffVorgaben?.split("\n").map((item2, index2) => {
                      var tmpkey = "";
                      var tmpval = "";
                      var tmppos = item2.indexOf(";");
                      if (tmppos >= 0) {
                        tmpkey = item2.substr(0, tmppos);
                        tmpval = item2.substr(tmppos + 1);
                      } else {
                        tmpkey = item2;
                        tmpval = item2;
                      }
                      return (
                        <MenuItem key={tmpval} value={tmpval} index={index2}>
                          {tmpval}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                )}
              </>
            )}

            <TextField
              value={selectedArtikel.NETTO}
              label="Netto"
              sx={{ mb: 2 }}
              fullWidth
              onFocus={(event) => {
                event.target.select();
              }}
              type="number"
              variant="standard"
              onChange={(e) => changeWerte(e.target.value, "NETTO")}
            ></TextField>

            <TextField value={selectedArtikel.STEUER} label="Steuer" sx={{ mb: 2 }} disabled fullWidth variant="standard"></TextField>
            <TextField
              value={selectedArtikel.STEUERSATZ}
              label="Steuersatz "
              sx={{ mb: 2 }}
              fullWidth
              variant="standard"
              onFocus={(event) => {
                event.target.select();
              }}
              type="number"
              onChange={(e) => changeWerte(e.target.value, "STEUERSATZ")}
            ></TextField>

            <TextField
              value={selectedArtikel.BETRAG}
              label="Brutto"
              fullWidth
              type="number"
              onFocus={(event) => {
                event.target.select();
              }}
              variant="standard"
              onChange={(e) => changeWerte(e.target.value, "BETRAG")}
            ></TextField>
            {fehlerFound && (
              <Typography align="center" color="red">
                Daten prüfen und ggf. korrigieren !
              </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <IconButton color="secondary" fullWidth onClick={() => saveArtikel()}>
                <SaveIcon />
              </IconButton>
              <IconButton
                color="secondary"
                fullWidth
                onClick={() => {
                  setEditModus(false), setFehlerFound(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
      </>
    );
  };
  return (
    <>
      <Dialog open={open} maxWidth="lg" fullWidth>
        <DialogContent>
          <Paper sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
            <Grid container>
              <Grid item sm={6}>
                <TextField
                  size="small"
                  fullWidth
                  label="Herkunftsland des Belegs"
                  select
                  value={belegWerte.SITZ ? belegWerte.SITZ : ""}
                  onChange={(e) => {
                    changeValue("SITZ", e.target.value);
                  }}
                >
                  <MenuItem key={"N"} value={"N"} index={"N"}>
                    Ausland
                  </MenuItem>
                  <MenuItem key={"J"} value={"J"} index={"J"}>
                    Deutschland
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item sm={6}>
                <TextField
                  label="Belegdatum"
                  type="date"
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled={lock}
                  onChange={(e) => changeValue("DATUM", e.target.value)}
                  value={belegWerte.DATUM ? belegWerte.DATUM : ""}
                />
              </Grid>
            </Grid>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    <TableCell width={"5%"}>Nr</TableCell>
                    <TableCell align="center" width={"20%"}>
                      Bezeichnung
                    </TableCell>
                    <TableCell align="center" width={"20%"}>
                      Artikel
                    </TableCell>
                    <TableCell width={"10%"} align="center">
                      Netto
                    </TableCell>
                    <TableCell width={"5%"} align="center">
                      MWST
                    </TableCell>
                    <TableCell width={"9%"} align="center">
                      Steuersatz %
                    </TableCell>
                    <TableCell width={"10%"} align="center">
                      Brutto
                    </TableCell>
                    <TableCell width={"2%"} align="center"></TableCell>
                    <TableCell width={"2%"} align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {artikel?.map((artikel, index) => {
                    return (
                      <TableRow key={index}>
                        {editModus && index === selectedArtikel?.index ? (
                          <>
                            <TableCell align="left">{index + 1 + "."}</TableCell>
                            <TableCell align="center">
                              <TextField
                                value={selectedArtikel.Artikelbezeichnung}
                                onChange={(e) => changeWerte(e.target.value, "Artikelbezeichnung")}
                                onFocus={(event) => {
                                  event.target.select();
                                }}
                              ></TextField>
                            </TableCell>
                            <TableCell align="center">
                              {artikelOptionen ? (
                                <TextField
                                  size="small"
                                  fullWidth
                                  label="Artikel"
                                  select
                                  onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                                  value={selectedArtikel?.ARTIKEL_KEY ? selectedArtikel?.ARTIKEL_KEY : ""}
                                >
                                  {artikelOptionen?.map((artikel) => {
                                    return (
                                      <MenuItem key={artikel.key} value={artikel.key} index={artikel.key}>
                                        {artikel.bez}
                                      </MenuItem>
                                    );
                                  })}
                                </TextField>
                              ) : (
                                <>
                                  {settings?.betreffVorgaben !== "" && settings?.betreffVorgaben !== undefined && (
                                    <TextField
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      label=""
                                      select
                                      onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                                      value={selectedArtikel?.ARTIKEL_KEY ? selectedArtikel?.ARTIKEL_KEY : ""}
                                    >
                                      {settings?.betreffVorgaben?.split("\n").map((item2, index2) => {
                                        var tmpkey = "";
                                        var tmpval = "";
                                        var tmppos = item2.indexOf(";");
                                        if (tmppos >= 0) {
                                          tmpkey = item2.substr(0, tmppos);
                                          tmpval = item2.substr(tmppos + 1);
                                        } else {
                                          tmpkey = item2;
                                          tmpval = item2;
                                        }
                                        return (
                                          <MenuItem key={tmpval} value={tmpval} index={index2}>
                                            {tmpval}
                                          </MenuItem>
                                        );
                                      })}
                                    </TextField>
                                  )}
                                </>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                onFocus={(event) => {
                                  event.target.select();
                                }}
                                value={selectedArtikel.NETTO}
                                onChange={(e) => changeWerte(e.target.value, "NETTO")}
                              ></TextField>
                            </TableCell>
                            <TableCell align="center">{selectedArtikel.STEUER}</TableCell>
                            <TableCell align="center">
                              <TextField
                                onFocus={(event) => {
                                  event.target.select();
                                }}
                                value={selectedArtikel.STEUERSATZ}
                                onChange={(e) => changeWerte(e.target.value, "STEUERSATZ")}
                              ></TextField>
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                onFocus={(event) => {
                                  event.target.select();
                                }}
                                value={selectedArtikel.BETRAG}
                                onChange={(e) => changeWerte(e.target.value, "BETRAG")}
                              ></TextField>
                            </TableCell>

                            <TableCell align="right">
                              <IconButton color="secondary" fullWidth onClick={() => saveArtikel()}>
                                <SaveIcon />
                              </IconButton>
                            </TableCell>
                            <TableCell align="right">
                              {" "}
                              <IconButton color="secondary" fullWidth onClick={() => setEditModus(false)}>
                                {" "}
                                <CloseIcon />{" "}
                              </IconButton>
                            </TableCell>
                            {fehlerFound && (
                              <Typography align="center" color="red">
                                Daten prüfen und ggf. korrigieren !
                              </Typography>
                            )}
                          </>
                        ) : (
                          <>
                            <TableCell align="left">{index + 1 + "."}</TableCell>
                            <TableCell align="center">{artikel.Artikelbezeichnung}</TableCell>
                            <TableCell align="center">
                              {artikelOptionen
                                ? artikelOptionen.find((e) => e.key === artikel.ARTIKEL_KEY)?.bez
                                : settings?.betreffVorgaben !== ""
                                ? settings?.betreffVorgaben?.split("\n").find((e) => e === artikel.ARTIKEL_KEY)
                                : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{artikel.NETTO}</TableCell>
                            <TableCell align="center">{artikel.STEUER}</TableCell>
                            <TableCell align="center">{artikel.STEUERSATZ}</TableCell>
                            <TableCell align="center">{artikel.BETRAG}</TableCell>
                            <TableCell align="right">
                              <IconButton color="secondary" disabled={lock || editModus} fullWidth onClick={() => editArtikel(artikel, index)}>
                                <EditIcon />
                              </IconButton>
                            </TableCell>
                            <TableCell align="right">
                              {" "}
                              <IconButton color="secondary" disabled={lock || editModus} fullWidth onClick={() => removeArtikel(index)}>
                                {" "}
                                <CloseIcon />{" "}
                              </IconButton>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    );
                  })}
                  {editModus && (selectedArtikel?.index > artikel?.length || artikel === undefined) && (
                    <TableRow key={""}>
                      <TableCell align="left">{selectedArtikel.index + "."}</TableCell>
                      <TableCell align="center">
                        {" "}
                        <TextField
                          value={selectedArtikel.Artikelbezeichnung}
                          onFocus={(event) => {
                            event.target.select();
                          }}
                          onChange={(e) => changeWerte(e.target.value, "Artikelbezeichnung")}
                        ></TextField>
                      </TableCell>
                      <TableCell align="center">
                        {artikelOptionen ? (
                          <TextField
                            size="small"
                            fullWidth
                            label="Artikel"
                            select
                            onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                            value={selectedArtikel?.ARTIKEL_KEY ? selectedArtikel?.ARTIKEL_KEY : ""}
                          >
                            {artikelOptionen?.map((artikel) => {
                              return (
                                <MenuItem key={artikel.key} value={artikel.key} index={artikel.key}>
                                  {artikel.bez}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        ) : (
                          <>
                            {settings?.betreffVorgaben !== "" && settings?.betreffVorgaben !== undefined && (
                              <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                label=""
                                select
                                onChange={(e) => changeWerte(e.target.value, "ARTIKEL_KEY")}
                                value={selectedArtikel?.ARTIKEL_KEY ? selectedArtikel?.ARTIKEL_KEY : ""}
                              >
                                {settings?.betreffVorgaben?.split("\n").map((item2, index2) => {
                                  var tmpkey = "";
                                  var tmpval = "";
                                  var tmppos = item2.indexOf(";");
                                  if (tmppos >= 0) {
                                    tmpkey = item2.substr(0, tmppos);
                                    tmpval = item2.substr(tmppos + 1);
                                  } else {
                                    tmpkey = item2;
                                    tmpval = item2;
                                  }
                                  return (
                                    <MenuItem key={tmpval} value={tmpval} index={index2}>
                                      {tmpval}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            )}
                          </>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          onFocus={(event) => {
                            event.target.select();
                          }}
                          value={selectedArtikel.NETTO}
                          onChange={(e) => changeWerte(e.target.value, "NETTO")}
                        ></TextField>
                      </TableCell>
                      <TableCell align="center">{selectedArtikel.STEUER}</TableCell>
                      <TableCell align="center">
                        <TextField
                          onFocus={(event) => {
                            event.target.select();
                          }}
                          value={selectedArtikel.STEUERSATZ}
                          onChange={(e) => changeWerte(e.target.value, "STEUERSATZ")}
                        ></TextField>
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          value={selectedArtikel.BETRAG}
                          onFocus={(event) => {
                            event.target.select();
                          }}
                          onChange={(e) => changeWerte(e.target.value, "BETRAG")}
                        ></TextField>
                      </TableCell>
                      <TableCell align="right">
                        <IconButton color="secondary" fullWidth onClick={() => saveArtikel()}>
                          <SaveIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="right">
                        {" "}
                        <IconButton color="secondary" fullWidth onClick={() => setEditModus(false)}>
                          {" "}
                          <CloseIcon />{" "}
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <Button
                id="addRow"
                fullWidth
                variant="contained"
                color="primary"
                disabled={editModus}
                startIcon={<AddIcon />}
                onClick={() => addArtikel(artikel.length)}
              >
                {t("Hinzufügen")}
              </Button>
            </TableContainer>
          </Paper>
          <Paper sx={{ display: { sm: "block", xs: "block", md: "none", lg: "none" } }}>
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  label="Herkunftsland des Belegs"
                  select
                  value={belegWerte.SITZ ? belegWerte.SITZ : ""}
                  onChange={(e) => {
                    changeValue("SITZ", e.target.value);
                  }}
                >
                  <MenuItem key={"N"} value={"N"} index={"N"}>
                    Ausland
                  </MenuItem>
                  <MenuItem key={"J"} value={"J"} index={"J"}>
                    Deutschland
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Belegdatum"
                  type="date"
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled={lock}
                  onChange={(e) => changeValue("DATUM", e.target.value)}
                  value={belegWerte.DATUM ? belegWerte.DATUM : ""}
                />
              </Grid>
            </Grid>
            {displayMobileAnsicht()}

            <Button
              id="addRow"
              fullWidth
              variant="contained"
              color="primary"
              disabled={editModus}
              startIcon={<AddIcon />}
              onClick={() => addArtikel(artikel.length)}
            >
              {t(" Artikel Hinzufügen")}
            </Button>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Zurück</Button>
          {/* <Button
            variant="contained"
            color="primary"
            disabled={lock}
            // onClick={() => addExpense(neueAusgabeWerte, addExpenseModal)}
          ></Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ArtikelTable;
